var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeatureTileIcon06(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.58 20.424a1 1 0 00-.761-.294c-14.028.732-19.21 13.228-19.26 13.354a1 1 0 00.22 1.08l5.657 5.657a1 1 0 001.085.218c.125-.051 12.554-5.291 13.348-19.253a1 1 0 00-.289-.762zm-8.166 10.99a2 2 0 11-2.829-2.828 2 2 0 012.829 2.828z",
    fill: "#dd1f1f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.113 38.844a2.844 2.844 0 114.022 4.022C24.024 43.977 20 44 20 44s0-4.046 1.113-5.156zM30.357 22.341a8.911 8.911 0 00-7.835 2.484c-.535.54-1 1.144-1.384 1.8a1 1 0 00.155 1.215l1.989 1.99a26.623 26.623 0 017.075-7.489zM41.659 33.643a8.911 8.911 0 01-2.484 7.835c-.54.535-1.144 1-1.8 1.384a1 1 0 01-1.215-.155l-1.99-1.989a26.623 26.623 0 007.489-7.075z",
    fillOpacity: 0.8,
    fill: "#CCD4FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureTileIcon06);
export default __webpack_public_path__ + "static/media/feature-tile-icon-06.c445747f4a9ebdb4da6ca2644ea40cc7.svg";
export { ForwardRef as ReactComponent };